// extracted by mini-css-extract-plugin
module.exports = {"container":"board_container__2vzXs"};